<template>
  <div></div>
</template>


<script>
export default {
  name: 'PollManageStats',
  data: () => ({}),
};
</script>



// WEBPACK FOOTER //
// src/components/poll/manage/Stats.vue